import basicController from 'servicestack/basic.controller.properties'
import Product from 'emun.shopping/product.model'
import templateUrl from 'emun.stockchecker/stock-checker-search.htm'
import $session from 'servicestack/session'
import ProductQuery from 'emun.shopping/product-query.service'

class StockCheckerSearchController {
    constructor($rootScope, $state, createAutoQuery, createServiceBus) {
        basicController(this)
        this.$state = $state;
        this.$session = $session;
    }
    findProduct(id) {
        this.$state.go('stockcheck.product', { productId: id });
    }
 
}

let StockCheckerSearch = {
    controller: StockCheckerSearchController,
    require:{
        container: '^stockChecker'
    },
    templateUrl($element, $attrs) {
        return $attrs.templateUrl || templateUrl
    }
}

angular.module('emun.stockchecker').component('stockCheckerSearch', StockCheckerSearch);


